import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

import Card from '../Card';

export const Container = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(6, 1fr);
	gap: 2rem;
	margin-top: 2rem;

	@media ${Breakpoints.tablet} {
		padding: 0 var(--padding-2) var(--padding-5) var(--padding-2) !important;
		grid-template-columns: 1fr;
	}
`;

export const EmptyDataCard = styled(Card)`
	grid-column: span 6;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 1rem;
	padding: 4rem;
`;
